import type { Language } from '$lib/i18n';

const platformForSMEData: Record<Language, string[]> = {
	en: [
		'We handle all OT protocols',
		'Real-time dashboards and alerts',
		'OEE tracking with Pareto analysis',
		'No developers required'
	],
	no: [
		'Vi håndterer alle OT-protokoller',
		'Sanntids dashbord og varsler',
		'OEE-sporing med Pareto-analyse',
		'Ingen utviklere nødvendig'
	]
};

const platformForEnterpriseData: Record<Language, string[]> = {
	en: [
		'OT protocols → REST API translation',
		'Python and TypeScript SDKs',
		'Real-time streaming and webhooks',
		'Your developers build on our data layer'
	],
	no: [
		'OT-protokoller → REST API-oversetting',
		'Python og TypeScript SDK-er',
		'Sanntidsstrømming og webhooks',
		'Dine utviklere bygger på vårt datalag'
	]
};

/** Returns localized SME platform bullet points for the analytics page. */
export function getPlatformForSME(lang: Language): string[] {
	return platformForSMEData[lang];
}

/** Returns localized enterprise platform bullet points for the analytics page. */
export function getPlatformForEnterprise(lang: Language): string[] {
	return platformForEnterpriseData[lang];
}
